import Cookies from 'js-cookie'
import { Outlet } from 'react-router-dom'
import { useAuthContext } from '../contexts/AuthContext'
import NotFoundPage from '../pages/404'

export default function RequireAuth() {
  const { isAuthenticated } = useAuthContext()
  // session_hint is a non-HttpOnly cookie set by the backend on login.
  // It lets us detect an active session on first render before React state hydrates.
  const hasSession = !!Cookies.get('session_hint')

  if (!isAuthenticated && !hasSession) {
    return <NotFoundPage />
  }

  return <Outlet />
}
